module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--2--create-8e8e6fbf.png";